import { defineMessage } from 'services/localization';

export const messages = {
    nsVendorReferenceFieldText: defineMessage('reference'),
    nsPOReferenceFieldText: defineMessage('transaction_number_1'),
    nsTermsFieldText: defineMessage('terms'),
    nsDateFieldText: defineMessage('date'),
    nsDueDateFieldText: defineMessage('receive_by_1'),
    nsEmployeeFieldText: defineMessage('employee'),
    nsIncotermsFieldText: defineMessage('incoterm'),
    nsDepartmentFieldText: defineMessage('department'),
    nsClassFieldText: defineMessage('class'),
    nsLocationFieldText: defineMessage('location'),
    nsMemoFieldText: defineMessage('memo'),
};
